import { SurveyEditPage } from './survey.edit.page';

export default SurveyEditPage;
